import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Button, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap'
import { connect } from 'react-redux'
import NotificationDropdown from '../Common/NotificationDropdown'
import ProfileMenu from '../Common/ProfileMenu'
import BackendSelector from '../Common/BackendSelector'
import ExpedientBtn from '../Common/ExpedientBtn'
import { getRegs } from '../../utils/fc'
import { enforceBackendForUser, getBackendTarget } from '../../config/backendEnv'
import HeaderNfLiberadasMenu from './HeaderNfLiberadasMenu'
import { isFinanceSectorUser } from '../../utils/setorFinanceiro'
import { startBadgePoll } from './headerBadgePoll'
import logoSmLight from '../../assets/images/logo192.png'
import logoLight from '../../assets/images/logo-light.png'
import academyLogo from '../../assets/images/academyLogo.jpeg'
import todoIcon from '../../assets/icons/microsoft/todo.png'
import outlookIcon from '../../assets/icons/microsoft/outlook.png'
import onedriveIcon from '../../assets/icons/microsoft/onedrive.png'
import wordIcon from '../../assets/icons/microsoft/word.png'
import excelIcon from '../../assets/icons/microsoft/excel.png'
import powerpointIcon from '../../assets/icons/microsoft/powerpoint.png'
import sharepointIcon from '../../assets/icons/microsoft/sharepoint.png'
import teamsIcon from '../../assets/icons/microsoft/teams.png'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toolsMenuOpen: false,
      pendingTasksCount: 0,
      showNfLiberadasIcon: false,
    }
    this._nfAlive = true
  }

  refreshNfIcon = () => {
    const user = this.props.auth?.user
    const seq = (this._nfSeq || 0) + 1
    this._nfSeq = seq
    isFinanceSectorUser(user).then((ok) => {
      if (!this._nfAlive || this._nfSeq !== seq) return
      this.setState({ showNfLiberadasIcon: !!ok })
    }).catch(() => {
      if (!this._nfAlive || this._nfSeq !== seq) return
      this.setState({ showNfLiberadasIcon: false })
    })
  }

  componentDidMount() {
    this._nfAlive = true
    enforceBackendForUser(this.props.auth?.user)
    this.stopTasksPoll = startBadgePoll(this.loadPendingTasksCount)
    this.refreshNfIcon()
  }

  componentWillUnmount() {
    this._nfAlive = false
    if (this.stopTasksPoll) this.stopTasksPoll()
  }

  componentDidUpdate(prevProps) {
    const prevUser = prevProps.auth?.user
    const user = this.props.auth?.user
    const prevPath = prevProps.location?.pathname
    const path = this.props.location?.pathname

    if (user?.pf_id !== prevUser?.pf_id || String(user?.pf_setoresId || '') !== String(prevUser?.pf_setoresId || '')) {
      this.refreshNfIcon()
    }

    if (user?.pf_id && user.pf_id !== prevUser?.pf_id) {
      enforceBackendForUser(user)
      this.loadPendingTasksCount()
    } else if (prevPath === '/task' && path !== '/task') {
      this.loadPendingTasksCount()
    }
  }

  loadPendingTasksCount = async () => {
    const { user } = this.props.auth || {}
    const pfId = user?.pf_id || user?.oikos_id
    if (!pfId) return

    try {
      const tasks = await getRegs(
        'task',
        { pf_id: pfId, taskStatus_id: 1 },
        { task_mae: 'task_mae' },
      )
      const pendingTasksCount = (tasks || []).filter(
        (task) => task.task_mae !== undefined && task.task_mae !== null && task.task_mae !== '',
      ).length
      this.setState({ pendingTasksCount })
    } catch (err) {
      console.log('Erro ao carregar contagem de tarefas pendentes', err)
    }
  }

  toggleToolsMenu = () => {
    this.setState(prevState => ({ toolsMenuOpen: !prevState.toolsMenuOpen }))
  }

  onMouseEnterTools = () => {
    this.setState({ toolsMenuOpen: true })
  }

  onMouseLeaveTools = () => {
    this.setState({ toolsMenuOpen: false })
  }

  render() {
    const { props } = this
    const { user } = this.props.auth
    const { pendingTasksCount } = this.state
    const onedriveMailPath = user ? user.mail.replaceAll(/[@.]/g, '_') : false
    const backendTarget = getBackendTarget()
    const isProdBackend = backendTarget === 'production'
    const { showNfLiberadasIcon } = this.state
    console.log('props = ', props)
    return (
    <React.Fragment>
      <div style={{ backgroundColor: isProdBackend ? '#f46a6a' : '#ffcc00', color: isProdBackend ? '#fff' : '#000', textAlign: 'center', width: '100%', height: '30px', padding: '5px 0', fontWeight: 'bold', position: 'fixed', top: 0, left: 0, zIndex: 1005, boxSizing: 'border-box' }}>
        {isProdBackend ? 'Backend de produção' : 'Ambiente de Testes'}
      </div>
      <style>{`
        #page-topbar { top: 30px !important; }
        .topnav { margin-top: 100px !important; }
        .page-content { margin-top: 100px !important; }
        .vertical-menu { top: 100px !important; }
        .header-task-icon {
          position: relative;
          display: inline-block;
          line-height: 0;
        }
        .header-task-badge {
          position: absolute;
          bottom: -2px;
          right: -4px;
          min-width: 16px;
          height: 16px;
          padding: 0 4px;
          border-radius: 8px;
          background-color: #f46a6a;
          color: #fff;
          font-size: 10px;
          font-weight: 700;
          line-height: 16px;
          text-align: center;
          box-shadow: 0 0 0 2px #fff;
        }
        .header-nf-icon svg {
          display: block;
        }
      `}</style>
    <header id="page-topbar">
    {user && (
      <>
    <div className="navbar-header">
      <div className="d-flex">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSmLight} alt="" height="36" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="" height="36" />
            </span>
          </Link>

        </div>
        <Button
          color="none"
          type="button"
          size="sm"
          onClick={() => props.openLeftMenuCallBack()}
          className="px-3 font-size-24 d-lg-none header-item hamburguer-menu-icon"
          data-toggle="collapse"
          data-target="#topnav-menu-content"
        >
          <i className="ri-menu-2-line align-middle" />
        </Button>
      </div>
      <div className="d-flex">
      { user.perm_id === 1 && <BackendSelector /> }
      { user.perm_id === 1 &&
      <a className="d-flex align-items-center justify-content-center p-3 d-xs-none header-item font-size-22" target='_blank' href="https://ecossis-solucoes-ambientais.github.io/nft-oikos/">
        <svg viewBox="0 0 200 200" width="28" height="28">
          {/* Front face */}
          <polygon points="50,50 150,50 150,150 50,150" fill="#4CAF50" />

          {/* Top face */}
          <polygon points="50,50 100,20 200,20 150,50" fill="#81C784" />

          {/* Side face */}
          <polygon points="150,50 200,20 200,120 150,150" fill="#388E3C" />
        </svg>
      </a>
      }
      <Link className="d-flex align-items-center justify-content-center p-3 d-xs-none header-item font-size-22" to="/task">
        <span className="header-task-icon mr-2">
          <img
            alt="Tarefas"
            src={todoIcon}
            width={28}
            height={28}
          />
          {pendingTasksCount > 0 && (
            <span className="header-task-badge">
              {pendingTasksCount > 99 ? '99+' : pendingTasksCount}
            </span>
          )}
        </span>
      </Link>
      <Link
        className="d-flex align-items-center justify-content-center p-3 d-xs-none header-item font-size-22"
        to="/documentos"
        title="Documentos"
      >
        <i className="ri-folder-open-line" style={{ color: '#fff', fontSize: 22 }} aria-hidden />
      </Link>
      {showNfLiberadasIcon && <HeaderNfLiberadasMenu />}
      <Dropdown 
        isOpen={this.state.toolsMenuOpen} 
        toggle={this.toggleToolsMenu} 
        onMouseEnter={this.onMouseEnterTools}
        onMouseLeave={this.onMouseLeaveTools}
        className="d-flex align-items-center justify-content-center"
      >
        <DropdownToggle tag="a" className="p-3 d-xs-none header-item font-size-22 cursor-pointer" style={{ cursor: 'pointer' }}>
          <img
            alt="Ferramentas"
            src={outlookIcon}
            className="mr-2"
            width={28}
            height={28}
          />
        </DropdownToggle>
        <DropdownMenu right>
          <a
            className="dropdown-item"
            href="https://outlook.office365.com/mail/inbox/"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="Outlook" src={outlookIcon} className="mr-2" width={28} height={28} />
            Outlook
          </a>
          <a
            className="dropdown-item"
            href={`https://ecossissolucoes-my.sharepoint.com/personal/${onedriveMailPath}/_layouts/15/onedrive.aspx`}
            target="_blank"
            rel="noreferrer"
          >
            <img alt="OneDrive" src={onedriveIcon} className="mr-2" width={28} height={28} />
            OneDrive
          </a>
          <a
            className="dropdown-item"
            href="https://www.office.com/launch/word?auth=2"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="Word" src={wordIcon} className="mr-2" width={28} height={28} />
            Word
          </a>
          <a
            className="dropdown-item"
            href="https://www.office.com/launch/excel?auth=2"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="Excel" src={excelIcon} className="mr-2" width={28} height={28} />
            Excel
          </a>
          <a
            className="dropdown-item"
            href="https://www.office.com/launch/powerpoint?auth=2"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="PowerPoint" src={powerpointIcon} className="mr-2" width={28} height={28} />
            PowerPoint
          </a>
          <a
            className="dropdown-item"
            href="https://ecossissolucoes.sharepoint.com/sites/PortaldeColaboradores"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="SharePoint" src={sharepointIcon} className="mr-2" width={28} height={28} />
            SharePoint
          </a>
          <a
            className="dropdown-item"
            href="https://teams.microsoft.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="Teams" src={teamsIcon} className="mr-2" width={28} height={28} />
            Teams
          </a>
        </DropdownMenu>
      </Dropdown>
      {/*
      */}
      <a target="_blank" rel="noopener noreferrer" href="https://ecossis.twygoead.com/users/login" className="logo logo-light">
        <span className="logo-lg" style={{borderRadius: '10px'}}>
          <img src={academyLogo} style={{borderRadius: '10px'}} alt="" height="36" />
        </span>
      </a>
        {props.location && props.location.pathname !== '/recursos-humanos/encerrar-expediente' && <ExpedientBtn />}
        {/* <NotificationDropdown /> */}
        <ProfileMenu />
      </div>
    </div>
    </>
    )}

    {!user && (
        <>
    <div className="navbar-header">
      <div className="d-flex">
        <div className="navbar-brand-box">
            <span className="logo-sm">
              <img src={logoSmLight} alt="" height="36" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="" height="36" />
            </span>
        </div>
      </div>
    </div>

        </>
      )
    }
  </header>
    </React.Fragment>
)}
    }
const mapStateToProps = state => ({ auth: state.auth })
export default withRouter(connect(mapStateToProps)(Header))
